import {
    DECELERATION_RATE,
    INITIAL_SPEEDUP,
    MAX_VELOCITY,
    VELOCITY_THRESHOLD,
} from './constants';
import Coordinates from './types/Coordinates';

class InertiaManager {
    private animationFrameId?: number;

    private velocity: Coordinates = { x: 0, y: 0 };

    private lastTime: number = Date.now();

    private lastPosition: Coordinates = { x: 0, y: 0 };

    constructor(
        private readonly onScroll: (x: number, y: number) => void,
        private readonly notifyUpdate: () => void
    ) {}

    updateVelocity(event: PointerEvent) {
        const currentTime = Date.now();
        const deltaTime = currentTime - this.lastTime;

        if (deltaTime > 0) {
            this.velocity = {
                x: (this.lastPosition.x - event.clientX) / deltaTime,
                y: (this.lastPosition.y - event.clientY) / deltaTime,
            };

            this.lastTime = currentTime;
            this.lastPosition = {
                x: event.clientX,
                y: event.clientY,
            };
        }
    }

    applyInertia() {
        if (
            Math.abs(this.velocity.x) < VELOCITY_THRESHOLD &&
            Math.abs(this.velocity.y) < VELOCITY_THRESHOLD
        ) {
            this.stop();
            return;
        }

        this.velocity.x *= DECELERATION_RATE;
        this.velocity.y *= DECELERATION_RATE;

        this.onScroll(this.velocity.x, this.velocity.y);
        this.notifyUpdate();

        this.animationFrameId = requestAnimationFrame(() =>
            this.applyInertia()
        );
    }

    startInertia() {
        this.velocity.x *= INITIAL_SPEEDUP;
        this.velocity.y *= INITIAL_SPEEDUP;

        this.velocity.x = Math.min(
            Math.max(this.velocity.x, -MAX_VELOCITY),
            MAX_VELOCITY
        );
        this.velocity.y = Math.min(
            Math.max(this.velocity.y, -MAX_VELOCITY),
            MAX_VELOCITY
        );

        this.applyInertia();
    }

    stop() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = undefined;
        }
    }

    reset() {
        this.lastTime = Date.now();
        this.velocity = { x: 0, y: 0 };
    }
}

export default InertiaManager;
